import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import { ProdutoModulo } from "../types/Produto";
import Swal from 'sweetalert2'

export default function usePutProdutos(onSuccess: () => void, isLoading: () => void) {
  return useMutation(({produtoAtual, id, data} : {produtoAtual : ProdutoModulo, id : number, data : ProdutoModulo}) => 
  {
    //@ts-ignore
    Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key])

    Object.assign(produtoAtual, data)
  
    return api.put(`${URLS.PRODUTOS_API}/${id}`, produtoAtual)
      .then((response: any) => {
        console.log(response)
        Swal.fire({
          title: "Produto Editado",
          text: "O produto foi editado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
          allowOutsideClick: false
        }).then(() => {
          onSuccess();
          queryClient.invalidateQueries();
        })
      })
      .catch((err: any) => {
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao editar o produto. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          })
        :
          Swal.fire({
            title: "Erro ao editar o produto",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          });
      }
    )
  })
}